export const urls = {
  VRATI_STAVKE_ZA_RN:
    'DokRNPustanjeURadStavke/vrati_stavke_dok_rn_pustanje_u_rad_za_id',
  INSERT_UPDATE_STAVKE: 'DokRNPustanjeURadStavke/dokRNPustanjeURadStavke_IU',

  DELETE_STAVKE: 'DokRNPustanjeURadStavke/dokRNPustanjeURadStavke_brisanje',
  GET_VRSTE_USLUGE:
    'DokRNServisniStavkeZaposleni/dok_rn_servisni_vrati_vrste_usluge_stavke_troskovi',
  GET_ISTORIJA_STAVKE:
    'DokRNPustanjeURad/dokRnPustanjeURad_vrati_unesene_stavke',
};
